import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

// for backward compatibility
const shortRelativeSyntaxRegex = /^(?<sign>[+\-])(?<value>\d+)\s(?<unit>months|days|minutes)$/;

// actual syntax format
const fullRelativeSyntaxRegex = /^(?<sign>[+\-])(?<value>\d+)\s(?<unit>months|days|minutes)\s(?<time>\d{2}:\d{2}:\d{2})$/;

export interface RelativeDate {
  time: string;
  sign: '+' | '-';
  value: string;
  unit: 'days' | 'months' | 'years';
}

export const defaultRelativeDate: RelativeDate = {
  time: '00:00:00',
  sign: '-',
  value: '0',
  unit: 'days',
};

function getRelativeValues(parsed: { [name: string]: string }): RelativeDate {
  return {
    sign: (parsed.sign ?? '-') as '+' | '-',
    value: parsed.value ?? '0',
    unit: (parsed.unit ?? 'days') as 'days' | 'years' | 'months',
    time: parsed.time ?? '00:00:00',
  };
}

function tryParseRelativeDate(value: string) {
  const fromFull = fullRelativeSyntaxRegex.exec(value)?.groups;

  if (undefined !== fromFull) {
    return getRelativeValues(fromFull);
  }

  const fromShort = shortRelativeSyntaxRegex.exec(value)?.groups;

  if (undefined !== fromShort) {
    return getRelativeValues(fromShort);
  }

  return undefined;
}

// Sometimes seconds doesn't come
export function fixSecondsInTime(time: string) {
  return /^\d{2}:\d{2}$/.test(time) ? `${time}:00` : time;
}

export function formForRelativeDate(value: string) {
  const parsed = tryParseRelativeDate(value) ?? defaultRelativeDate;

  return new UntypedFormGroup({
    sign: new UntypedFormControl(parsed.sign),
    value: new UntypedFormControl(parsed.value),
    unit: new UntypedFormControl(parsed.unit),
    time: new UntypedFormControl(parsed.time),
  });
}
